import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Link} from "react-router-dom"

class Sku extends Component {
    render() {
        const {sku, id} = this.props

        return (
            <td className="Type">
                <Link to={`/sku-detail/${id}`}>{sku}</Link>
            </td>
        )
    }
}

Sku.propTypes = {
    sku: PropTypes.string
}

export default Sku